module.exports = __webpack_public_path__ + "static/media/SchoolINTGymSDLightsA0035_bg_clean_v002.98c67c6d.webp";